import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFilterCircle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="filter-circle, sort"><path d="M21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12Z" stroke="currentColor" strokeWidth="1.5"/><path d="M8.75 12.5H15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M7.25 9.25L16.75 9.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M10.25 15.75H13.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFilterCircle;
